import React, { useEffect, useState } from "react";
import Superadmin_topbar from "../../Layouts/Superadmin_layout/Superadmin_topbar";
import "../../Styles/Pages/superadmin_dashboard.css";
import {
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import instance from "../../utils/api";
import ReactApexChart from "react-apexcharts";
import Chart from "react-apexcharts";
import { useNavigate, useParams } from "react-router-dom";

const Superadmin_dashboard = () => {
  const [dashboardData, setDashboardData] = useState();
  const [selectedYear, setSelectedYear] = useState(2025);
  const navigate = useNavigate();
  const getDashboardData = async (year) => {
    try {
      const response = await instance.get(`/dashboard/superadmin?year=${year}`);
      setDashboardData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getDashboardData(selectedYear);
  }, [selectedYear]);

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const options = {
    labels: ["Active", "Inactive"],
    colors: ["#19864A", "#F24E1E"],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50px",
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              fontSize: "16px",
              color: "#323232",
              fontWeight: "700",
              fontFamily: "Poppins",
              lineHeight: "21.78px",
            },
          },
        },
      },
    },
  };

  const chartOptions = {
    series: [
      {
        name: "Field Officers Count",
        data: dashboardData?.fd_month_counts,
        color: "#00A651",
      },
    ],
    options: {
      chart: {
        height: 500,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
        width: 2,
      },
      yaxis: {
        title: {
          text: "Field Officers Count",
          // offsetX: -5, // Adjust horizontal offset for title positioning
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#333",
          },
        },
      },
      grid: {
        row: {
          colors: ["#FFFFFF", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      legend: {
        position: "right",
        offsetY: 7,
        height: 230,
      },
    },
  };

  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <Superadmin_topbar />
      {dashboardData ? (
        <section className="superadmin_header">
          <div className="overview">Overview Section</div>
          <div className="dasboard-container">
            <Card
              onClick={() => navigate("/superadmin/Vendors")}
              sx={{
                width: "650px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
                height: "120px",
                cursor: "pointer",
              }}
            >
              <CardContent>
                <Typography className="text">Total Vendors</Typography>
                <Typography className="text-value">
                  {dashboardData?.total_vendors}
                </Typography>
              </CardContent>
            </Card>
            <Card
              sx={{
                width: "650px",
                height: "120px",
                boxShadow: "0px 2px 4px 0px rgba(0,0,0,0.1)",
              }}
            >
              <CardContent>
                <Typography className="officer-text">
                  Total Field Officers
                </Typography>
                <Typography className="officer-text-value">
                  {dashboardData?.total_fieldofficers}
                </Typography>
              </CardContent>
            </Card>
          </div>
          <div className="pie-chart-section">
            <div className="charts-section">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={5}>
                  <div className="piechart">
                    <Typography variant="h5">Vendors Status</Typography>
                    <Chart
                      options={options}
                      series={[
                        dashboardData?.active_vendors,
                        dashboardData?.inactive_vendors,
                      ]}
                      type="donut"
                      height={200}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={7}>
                  <div className="wavechart">
                    <Typography variant="h5" className="linechart-header">
                      Field Officers Trend
                      <FormControl
                        variant="outlined"
                        sx={{ width: "100px", marginBottom: "2px" }}
                      >
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                          labelId="year-select-label"
                          id="year-select"
                          value={selectedYear}
                          onChange={handleYearChange}
                          label="Year"
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 150,
                              },
                            },
                          }}
                        >
                          {Array.from({ length: 12 }, (_, i) => 2024 + i).map(
                            (year) => (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Typography>
                    <ReactApexChart
                      options={chartOptions.options}
                      series={chartOptions.series}
                      type="line"
                      height={200}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </section>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Superadmin_dashboard;
